import getDayKey from "./getDayKey";
import getMomentDateObj from "./getMomentDateObj";
import getMomentNow from "./getMomentNow";
import setMomentDateObjZero from "./setMomentDateObjZero";
import sortPerformancesByDate from "./sortPerformancesByDate";

const getPerformancesIntervallByMovies = (items, order, filterPerformances, timezone, activeFilters, clusterCinemaActive, activeCinema, startDate, endDate) => {
    const now = getMomentNow(timezone)
    //TESTING COUNTDOWN!!!
    // const now = getMomentDateObj(1711120780000, timezone)
    const perfIntervall = {}
    const perfIntervallOrder = []

    order.map(itemId => {
        const item = items[itemId]
        const containsOv = _.find(item.technologyAttributes, attribute => {
            return attribute.id === 'overgegerg'
        })
        const performances = item.performances
        const itemTitle = item.titleDisplay ? item.titleDisplay : containsOv && item.origTitle ? item.origTitle : item.title
        const technologyAttributes = item.technologyAttributes
        const posterAttribute = item.posterAttribute
        const alternativeLinks = item.alternativeLinks
     
        let purchaseblePerformances =  _.filter(performances, performance => {
            const {limitations} = performance

            if(limitations.visibleFrom) {
                const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)

                return now.isAfter(performanceDate)
            } else {
                return true
            }
        })
        let performancesFiltered
        
        if(filterPerformances) {
            performancesFiltered = purchaseblePerformances.filter(perf => filterPerformances.includes(perf.id))
        } else {
            performancesFiltered = purchaseblePerformances
        }

        if(activeFilters && activeFilters.theatreName) {
            const queryStringValue = activeFilters.theatreName
            const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]

            performancesFiltered = _.filter(performancesFiltered, performance => {
                return _.contains(filterValues, performance.theatreID)
            })
        }
    
            
        if(activeFilters && activeFilters.technical) {
            const queryStringValue = activeFilters.technical
            const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
            
            performancesFiltered = _.filter(performancesFiltered, performance => {
                const attributesFiltered = _.filter(performance.attributes, attribute => {
                    return _.contains(filterValues, attribute.id)
                })
                if(attributesFiltered && attributesFiltered.length !== 0) {
                    return performance
                }

            })
        }

        if(activeCinema) {
            performancesFiltered = _.filter(performancesFiltered, performance => {
                const {cinema} = performance
                if(activeCinema === cinema || clusterCinemaActive) {
                    return performance
                }
            })
        }

        performancesFiltered.map((perf, index) => {
            const momentPerfDate = getMomentDateObj(perf.timeUtc, timezone)
            const momentPerfDateZero =setMomentDateObjZero(momentPerfDate.clone())
            const lookForRange = startDate || endDate ? true : false 
            const isInDateRange = startDate && endDate ? momentPerfDateZero.isSameOrBefore(endDate) && momentPerfDateZero.isSameOrAfter(startDate) : startDate && !endDate ? momentPerfDateZero.isSame(startDate) : false

            if((lookForRange && isInDateRange && momentPerfDate.isSameOrAfter(now)) || (!lookForRange && momentPerfDate.isSameOrAfter(now)) ) {
                const key = getDayKey(momentPerfDate)
                const itemPerfObj = {
                    'moviePk': itemId,
                    'movieTitle': itemTitle,
                    'technologyAttributes': technologyAttributes,
                    'posterAttribute': posterAttribute,
                    'alternativeLinks': alternativeLinks,
                    ... perf
                }

                if(perfIntervall.hasOwnProperty(key)) {
                    perfIntervall[key].push(itemPerfObj)
                    perfIntervall[key] = sortPerformancesByDate(perfIntervall[key])
                } else {
                    perfIntervall[key] = [itemPerfObj]
                    perfIntervallOrder.push(key)
                }
            }
        })
    })

    return {
        perfItems: perfIntervall,
        perfOrder: perfIntervallOrder.sort() // ??
    }
}

export default getPerformancesIntervallByMovies